import React, { useState } from "react";
import { HStack, Button, Input, Text } from "@chakra-ui/react";

export default function DateRangeFilter({ initialFrom, initialTo, onApply, isLoading }) {
  const [localFrom, setLocalFrom] = useState(initialFrom);
  const [localTo, setLocalTo] = useState(initialTo);
  const [error, setError] = useState("");

  const now = new Date();
  const today = now.toISOString().split("T")[0];

  const handleApply = () => {
    const fromDate = new Date(localFrom);
    const toDate = new Date(localTo);

    if (toDate < fromDate) {
      setError("To date cannot be before From date.");
      return;
    }

    const diffInMs = toDate.getTime() - fromDate.getTime();
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

    if (diffInDays > 31) {
      setError("Date range cannot exceed 31 days.");
      return;
    }
    setError("");
    onApply({ from: localFrom, to: localTo });
  };

  return (
    <div>
      <HStack spacing={3} align="center">
        <div>
          <label htmlFor="from-date">From</label>
          <Input
            id="from-date"
            type="date"
            value={localFrom}
            max={today}
            onChange={(e) => setLocalFrom(e.target.value)}
            size="sm"
            isDisabled={isLoading}
          />
        </div>

        <div>
          <label htmlFor="to-date">To</label>
          <Input
            id="to-date"
            type="date"
            value={localTo}
            min={localFrom}
            max={today}
            onChange={(e) => setLocalTo(e.target.value)}
            size="sm"
            isDisabled={isLoading}
          />
        </div>

        <Button onClick={handleApply} colorScheme="blue" size="xs" isLoading={isLoading} mt={6}>
          Apply
        </Button>
      </HStack>
      {error && (
        <Text color="red.500" fontSize="sm" mt={2}>
          {error}
        </Text>
      )}
    </div>
  );
}
